/**
 * @desc 查询挂牌商品分页列表
 */
import { PageListingItem, ListingQuery } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryListingPageParameter = ListingQuery

const method = 'GET'
const url = '/trade/member/listing/page'

export const queryListingPageApi = (
  params?: QueryListingPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageListingItem>({
    method,
    url,
    params,
    ...config
  })
}

queryListingPageApi.method = method
queryListingPageApi.url = url
